module.exports = __webpack_public_path__ + "img/student_add.af9c78f3.png";